import { render, staticRenderFns } from "./MatchingProducts.vue?vue&type=template&id=ce8626aa&scoped=true&"
import script from "./MatchingProducts.vue?vue&type=script&lang=js&"
export * from "./MatchingProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8626aa",
  null
  
)

export default component.exports